import React, {useState, useEffect, useRef, useContext} from 'react';
import { useTranslation } from "react-i18next";
import './settings.css';
// import Serviced_vehicles from './Components/serviced_vehicles.js';
import { Toast } from 'primereact/toast';
import { TabMenu } from 'primereact/tabmenu';
import ZaposleniHome from './componentsTabs/ZaposleniHome';
import KlijentiHome from './componentsTabs/KlijentiHome';
import VozilaHome from './componentsTabs/VozilaHome';
import FirmaHome from './componentsTabs/FirmaHome';
import AlarmiHome from './componentsTabs/AlarmiHome';
import StampaDokumentacijeHome from './componentsTabs/StampaDokumentacijeHome';
import KarticeHome from './componentsTabs/KarticeHome';
import Dnevnice from './componentsTabs/DnevniceHome';
import OslobadjajuciTekst from './componentsTabs/OslobadjajuciTekst';
import ObracunTuraHome from './componentsTabs/ObracunTuraHome';

// import Unos_artikla from './Tab_components/Artical/Unos_artikla';
// import Pregled_zaliha from './Tab_components/Pregled_zaliha/Pregled_zaliha';
// import Nova_prijemnica from './Tab_components/Nova_prijemnica/Nova_prijemnica';
// import Pregled_prijemnice from './Tab_components/Pregled_prijemnice/Pregled_prijemnice';
// import Nova_otpremnica from './Tab_components/Nova_otpremnica/Nova_otpremnica';
// import Pregled_otpremnice from './Tab_components/Pregled otpremnice/Pregled_otpremnice';
// import Magacin from './Tab_components/Magacin/Magacin';
// import Loading from '../../Loading/loading';
// import { AuthContext } from "../../Header/auth - context";
// import { useSelector } from 'react-redux';

const Administracija = () => {
  const { t } = useTranslation();

    const toast = useRef(null);
    const [activeIndex, setActiveIndex] = useState(0);
    const items = [
        { label: t('admin.tabZaposleni')},
        { label: t('admin.tabKlijenti')},
        { label: t('admin.tabVozila')},
        { label: t('admin.tabAlarmi')},
        { label: t('admin.tabStampaDok')},
        { label: t('admin.tabFirma')},
        { label: t('admin.tabKartice')},
        { label: t('admin.tabDnevnice')},
        { label: t('admin.tabOslobadjajuci')},
        { label: t('admin.tabObracunTura')}
    ];
    return(
        <div className="config_workspace">
        <Toast ref={toast} />
            <div id='config_tabs'>
                <TabMenu id='modelTabConfig' activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} style={{ marginBottom: '0' }} model={items} />
                {activeIndex === 0 &&
                    <ZaposleniHome/>
                }
                {activeIndex === 1 &&
                    <KlijentiHome/>
                }
                 {activeIndex === 2 &&
                    <VozilaHome/>
                }
                {
                    activeIndex === 3 &&
                    <AlarmiHome/>
                }
                 {
                    activeIndex === 4 &&
                    <StampaDokumentacijeHome/>
                }
                {
                    activeIndex === 5 &&
                    <FirmaHome/>
                }
                {   activeIndex === 6 &&
                    <KarticeHome/>}
                {   activeIndex === 7 &&
                    <Dnevnice/>}
                {   activeIndex === 8 &&
                    <OslobadjajuciTekst/>}
                {   activeIndex === 9 &&
                    <ObracunTuraHome/>}
            </div>

        </div>

    )
}


export default Administracija;
